import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  title: {
    fontWeight: 'bold',
  },
}))

export default styles
